import React from "react";
import ReactDOM from "react-dom";
import ActiveCampaignsReact from "./ActiveCampaigns";

class ActiveCampaigns extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.innerHTML = `<div id="root"></div>`;

    ReactDOM.render(React.createElement(ActiveCampaignsReact), this.querySelector("#root"));
  }
}

customElements.define("active-campaigns", ActiveCampaigns);
